import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import { Brand, Size, Color } from '../../../lib/theme';

import spacerStyles from './Spacer_styles';

interface InnerHTML {
  __html: string;
}

type CSSAlignItems =
  | 'normal'
  | 'stretch'
  | 'center'
  | 'start'
  | 'end'
  | 'flex-start'
  | 'flex-end'
  | 'self-start'
  | 'self-end'
  | 'left'
  | 'right'
  | 'baseline';

type CSSJustifyContent =
  | 'normal'
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly'
  | 'stretch';

export type StaticSize = Size | string | number;

export type ResponsiveSize = [StaticSize, StaticSize];

export interface SpacerProps {
  id?: string;
  className?: string;
  style?: {
    [key: string]: any;
  };
  brand?: Brand;
  align?: CSSAlignItems;
  justify?: CSSJustifyContent;
  reverse?: boolean;
  row?: boolean;
  split?: boolean;
  fill?: boolean;
  clip?: boolean;
  clipX?: boolean;
  clipY?: boolean;
  flex?: any;
  space?: ResponsiveSize | StaticSize;
  self?: ResponsiveSize | StaticSize;
  selfH?: ResponsiveSize | StaticSize;
  selfV?: ResponsiveSize | StaticSize;
  selfT?: ResponsiveSize | StaticSize;
  selfB?: ResponsiveSize | StaticSize;
  selfL?: ResponsiveSize | StaticSize;
  selfR?: ResponsiveSize | StaticSize;
  width?: number | string;
  relative?: boolean;
  separator?: Color;
  innerHTML?: InnerHTML;
  children?: React.ReactNode;
  onClick?: (...args: any[]) => any;
  setRef?: (node: HTMLDivElement) => HTMLDivElement;
  maxWidth?: number | string;
}

const Spacer = ({
  id,
  innerHTML,
  className,
  styles,
  children,
  style,
  onClick,
  setRef,
}: SpacerProps & StylesProps<typeof spacerStyles>) =>
  innerHTML ? (
    <div
      ref={setRef}
      id={id}
      style={style}
      className={cx(className, styles.container)}
      onClick={onClick}
      dangerouslySetInnerHTML={innerHTML as InnerHTML}
    />
  ) : (
    <div
      ref={setRef}
      id={id}
      style={style}
      className={cx(className, styles.container)}
      onClick={onClick}
    >
      {children}
    </div>
  );

export default styled(spacerStyles)(Spacer);
